// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../services/bao-utils";
import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import BaseViewModel from "./../factories/base-view-model";
import BaoMenu from "./../services/bao-menu";
import BaoUtils from "./../services/bao-utils";
import * as moment from "moment";
import { IJobDialogParameters, IJobDialogParametersConstructor } from "../interfaces/ijob-dialog-parameters";
class JobManagement extends BaseViewModel {
    NewsJobId = ko.observable("");
    JobName = ko.observable("");
    /** this is the NewsJob that is selected through the BaoSearcher */
    SelectedJob: KnockoutObservable<any> = ko.observable();
    /** this is the id (int) of the NewsJob above */
    SelectedJobId: number = -1;
    /** this is the selection of NewsJobQUEUE, that can be canceled. */
    SelectedJobsFromQueue: KnockoutObservableArray<any> = ko.observableArray<any>([]);
    /** with this we keep track of completed jobs that grey out the cancel button */
    CompleteDatesForCancelButton: number = 0;
    Sorting = ko.observableArray([]);
    DialogNewJobsParameterVM: IJobDialogParameters = null;
    AllJobs: KnockoutObservable<boolean> = ko.observable(true);
    AllJobsComputed = ko.pureComputed({
        read: () => {
            return !this.AllJobs();
        }, write: () => { }
    });
    JobQueueItems = ko.observableArray([]);
    SelectedJobQueueOfBindingForeachSelection = ko.observableArray([]);
    BindingForeachSelectionJobQueue: Bindings.foreachSelection = {
        data: this.JobQueueItems,
        mode: 'multi',
        pk: 'PrimaryKeyValue',
        selection: this.SelectedJobQueueOfBindingForeachSelection
    };
    PageIndex: KnockoutObservable<number> = ko.observable(0);
    PageSize: KnockoutObservable<number> = ko.observable(20);
    TotalRows: KnockoutObservable<number> = ko.observable(0);
    JobSearcherBinding = {
        ObjectId: this.NewsJobId,
        ObjectValue: 'JobName',
        SearchType: 'Bao-JobManagement',
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.SelectedJob,
        Enabled: this.AllJobsComputed
    };
    /** parameters for dialog */
    Interval: KnockoutObservable<string> = ko.observable("");
    Parameters: KnockoutObservable<string> = ko.observable("");
    PlaceholderHtmlElement: KnockoutObservable<HTMLElement> = ko.observable(null);
    DialogWidth: number = 650;
    _DialogTemplate: string;
    StartDateJs = ko.observable("");
    StartDateTimeBoxBinding = {
        value: this.StartDateJs,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol
    };
    StartDateTimePickerBinding = {
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol
    };
    ValidToJs = ko.observable("");
    ValidToTimeBoxBinding = {
        value: this.ValidToJs,
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol
    };
    ValidToTimePickerBinding = {
        mode: 'datetime',
        culture: Bao.Session.Language.Symbol
    };
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.TotalRows(0);
        this.TabPage = tabPage;
        let title = Bao.Session.GetMessage("msgJobManagement").then((result) => {
            this.TabPage.Title(result);
        });
        this.TabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage.IsActiveTab() == true) {
                switch (value.ActionKey()) {
                    case "JobManagementNew":
                        this.NewJob();
                        break;
                    case "JobManagementCancel":
                        this.CancelSelectedJobs();
                        break;
                    case "JobManagementRefresh":
                        this.Refresh();
                        break;
                }
            }
        }));
        this.SelectedJob.subscribe(() => {
            if (this.SelectedJob() != null) {
                this.SelectedJobId = this.SelectedJob().NewsJobID;
            }
            else {
                this.SelectedJobId = -1;
            }
            this.SelectedJobsFromQueue([]); // re-initialize the array when a Job(type) is selected through BAO searcher
            this.CompleteDatesForCancelButton = 0; //and this one too so we can use the button again :)
            this.CheckCancelButtonGreyOut();
            if (this.PageIndex() === 0) {
                this.Refresh();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.Sorting.subscribe(() => {
            this.Refresh();
        });
        this.PageIndex.subscribe(() => {
            this.Refresh();
        });
        this.PageSize.subscribe(() => {
            if (this.PageIndex() === 0) {
                this.Refresh();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.AllJobs.subscribe((newValue) => {
            if (newValue === true) {
                this.SelectedJob(null);
                this.JobName("");
            }
        });
    }
    SelectItem(item) {
        item["IsSelected"](!item["IsSelected"]());
        if (item["IsSelected"]()) {
            this.SelectedJobsFromQueue.push(item.NewsJobQueueID()); // add item to the array of selected jobs
            if (item["CompleteDat"]() != null) {
                this.CompleteDatesForCancelButton++;
            }
        }
        else {
            this.SelectedJobsFromQueue.remove(item.NewsJobQueueID()); // remove item from the array of selected jobs
            if (item["CompleteDat"]() != null) {
                this.CompleteDatesForCancelButton--;
            }
        }
        // check if cancel button should be greyed out
        this.CheckCancelButtonGreyOut();
    }
    CheckCancelButtonGreyOut() {
        BaoMenu.permissionEnable({ ActionKey: "JobManagementCancel", Enabled: this.CompleteDatesForCancelButton <= 0, Context: this.TabPage.Context() });
    }
    init() {
        var def = $.Deferred<void>();
        this.Refresh().then(() => {
            def.resolve();
        });
        return def.promise();
    }
    Refresh() {
        var def = $.Deferred();
        this.TabPage.IsLoading(true);
        Bao.post("JobManagement/GetJobQueueItems", JSON.stringify({
            Filter: this.SelectedJobId,
            Sorting: this.Sorting(),
            PageSize: this.PageSize(),
            PageIndex: this.PageIndex()
        }), (result) => {
            // cycle through each item and set its "IsSelected" according to previous selection (needed for paging)
            this.SelectedJobsFromQueue().forEach((job) => {
                result.Models.forEach((model) => {
                    if (model.NewsJobQueueID == job) {
                        model.IsSelected = true;
                    }
                });
            });
            ko.map.fromJS(result.Models, this.JobQueueItems);
            this.TotalRows(result.TotalRows);
            this.TabPage.IsLoading(false);
            def.resolve();
        });
        return def.promise();
    }
    CheckForCancelButtonDeactivation(time: Date) {
    }
    CancelSelectedJobs() {
        if (this.SelectedJobsFromQueue().length <= 0) {
            let noSelectionDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCancelJobsNoSelection"), "info");
        }
        else {
            let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCancelJobsQuestion"), "yesno");
            dialog.DialogResult.subscribe((yesNoResult) => {
                if (yesNoResult === true) {
                    this.TabPage.IsLoading(true);
                    Bao.post("JobManagement/CancelSelectedJobs", JSON.stringify({
                        SelectedJobs: this.SelectedJobsFromQueue()
                    })).then((cancelResult) => {
                        if (cancelResult.Success) {
                            let resultDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgCancelJobsSuccess"), "info");
                            this.Refresh();
                        }
                        else {
                            let resultDialog = new BaoDialog(Bao.Session.ApplicationName, cancelResult.Message, "info");
                        }
                        this.TabPage.IsLoading(false);
                    });
                }
            });
        }
    }
    GetNewDialog() {
        // first get dialog template once
        return $.when((() => {
            if (!this._DialogTemplate) {
                return Bao.post("JobManagement/NewJobDialog")
                    .then((result) => {
                        this._DialogTemplate = result.Template;
                    });
            }
        })())
            // when dialog template is loaded
            // create a new dialog
            .then(() => {
                let dialog = new BaoDialog(Bao.Session.ApplicationName);
                dialog.ViewModel(this);
                let okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                    this.CompleteCheckDialog()
                        .then((res) => {
                            if (res === false) {
                                return $.Deferred().reject();
                            }
                        })
                        .then(() => {
                            return Bao.post("JobManagement/SaveNewJob", JSON.stringify({
                                JobId: this.SelectedJobId,
                                StartDateString: this.StartDateJs(),
                                Interval: this.Interval(),
                                ValidToString: this.ValidToJs(),
                                Parameter: ko.unwrap(this.DialogNewJobsParameterVM.ParameterString)
                            }));
                        })
                        .then((result) => {
                            if (result.Saved == true) {
                                let successDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgJobManagementSaveSuccess"), "info");
                                dialog.Close();
                                this.Refresh();
                            }
                            else {
                                let failureDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgJobManagementSaveFailure"), "info");
                                dialog.Close();
                            }
                        })
                        .always(() => {
                            this.TabPage.IsLoading(false);
                        });
                }); //end btn-OK-click
                var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                    dialog.Close();
                });
                if (this.DialogWidth != null) {
                    dialog.Width(this.DialogWidth + "px");
                }
                dialog.Buttons([okButton, cancelButton]);
                dialog.Template(this._DialogTemplate);
                return dialog;
            });
    }
    /** gets the WebParamter (JS's ViewModel URL) of the currently selected JOB */
    GetSelectedJobWebParameter() {
        if (this.SelectedJob() && ko.unwrap(this.SelectedJob().ParametersWebUrl)) {
            return ko.unwrap(this.SelectedJob().ParametersWebUrl);
        }
        return null;
    }
    /** gets the "default" Paramter (tblNewsJob.Parameter) of the currently selected JOB */
    GetSelectedJobDefaultParameter() {
        if (this.SelectedJob() && ko.unwrap(this.SelectedJob().Parameter)) {
            return ko.unwrap(this.SelectedJob().Parameter);
        }
        return null;
    }
    NewJob() {
        // check if job is given
        if (this.JobName() == "") {
            let noJobDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgNoJobSelected"), "info");
            return null;
        }
        if (this.SelectedJob().StartAllowed === 0) {
            let startNotAllowedDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgStartNotAllowed"), "info");
            return null;
        }
        this.TabPage.IsLoading(true);
        // reset dialog data
        this.StartDateJs(this.GetNow());
        this.Interval("");
        this.ValidToJs(null);
        return this.GetNewDialog()
            .then((dialog) => {
                dialog.Open(null);
                let webparam = this.GetSelectedJobWebParameter();
                if (webparam) {
                    // get job's module via window.baorequire and the weparam-url
                    window.baorequire([ko.unwrap(webparam)], (IJobDialogParameterClass: IJobDialogParametersConstructor) => {
                        // call constructor
                        this.DialogNewJobsParameterVM = new IJobDialogParameterClass(this.PlaceholderHtmlElement(), this.GetSelectedJobDefaultParameter());
                        // check if Job's Parameter-VM initialization is done
                        $.when(this.DialogNewJobsParameterVM.IsReady)
                            .then(() => {
                                this.TabPage.IsLoading(false);
                            });
                    });
                }
                else {
                    this.DialogNewJobsParameterVM = null;
                    this.TabPage.IsLoading(false);
                }
            });
    }
    /**
     * Checks the Dialog if valid and completed and shows message if failed
     * @returns true if everything is OK, otherwise false
     */
    CompleteCheckDialog(): JQueryPromise<boolean> {
        //mandatory fields
        if (this.StartDateJs() == "") {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return $.Deferred<boolean>().resolve(false).promise();
        }
        // logical fields
        if (typeof this.ValidToTimeBoxBinding.value() !== "undefined" && this.ValidToTimeBoxBinding.value() !== null && this.ValidToTimeBoxBinding.value() !== "" && this.ValidToTimeBoxBinding.value() < this.StartDateTimeBoxBinding.value()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgJobManagementAddDialogInvalidFromToFields"), "info");
            return $.Deferred<boolean>().resolve(false).promise();
        }
        if (this.Interval() !== null && typeof this.Interval() !== "undefined") {
            // checks if something else like an Digit in Interval?!
            if (/\D/.test(this.Interval())) {
                new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgJobManagementAddDialogInvalidInterval"), "info");
                return $.Deferred<boolean>().resolve(false).promise();
            }
        }
        // param interface
        if (this.DialogNewJobsParameterVM != null) {
            return this.DialogNewJobsParameterVM.CompleteCheck()
                .done((succeed) => {
                    if (!succeed) {
                        new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                    }
                });
        }
        return $.Deferred<boolean>().resolve(true).promise();
    }
    GetNow() {
        return moment(moment.now()).format(Bao.Utils.DateTimeFormat);
    }
}
export default JobManagement;